import { render, staticRenderFns } from "./NewPatientMainCard.vue?vue&type=template&id=fd2eab9c&scoped=true&"
import script from "./NewPatientMainCard.vue?vue&type=script&lang=js&"
export * from "./NewPatientMainCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2eab9c",
  null
  
)

export default component.exports